import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const changePasswordApi = async (payload) => {
  const accessToken = localStorage.getItem("accessToken");

  try {
    const response = await axios.post(
      `${API_URL}auth/change-password`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error changing password:", error);
    throw error;
  }
};

export const forgotPasswordApi = async (payload) => {
  try {
    const { data } = await axios.post(
      `${API_URL}reset-password/send-email`,
      payload
    );

    return data;
  } catch (error) {
    console.error("Error in forgot password API:", error);
    throw error?.response?.data || error;
  }
};

export const resetPasswordApi = async (payload) => {
  try {
    const { data } = await axios.post(
      `${API_URL}/reset-password/verify-token-and-update-password`,
      payload
    );

    return data;
  } catch (error) {
    console.error("Error in forgot password API:", error);
    throw error?.response?.data || error;
  }
};